import { DrawerTypes } from '@/common/Drawer/types';
import { Offcanvas } from 'react-bootstrap';
import { ReactElement } from 'react';
import { getClasses } from '@/utils';

const DrawerHeader = ({ title, icon, children, ...headerProps }: DrawerTypes.HeaderProps): ReactElement => {
  // If nothing provided show nothing
  if (!title && !icon && !children) return null;
  return (
    <Offcanvas.Header {...headerProps} className={getClasses('Drawer-Header', headerProps.className)}>
      {children}
      {!children && (title || icon) && (
        <Offcanvas.Title className="Drawer-Title">
          {icon}
          {title}
        </Offcanvas.Title>
      )}
    </Offcanvas.Header>
  );
};

export default DrawerHeader;
